import { FormattedMessage } from 'react-intl'
import { LabelWithIndicator, MenuItem, SelectField } from '@carto/meridian-ds/components'
import { Tooltip, styled } from '@mui/material'
import { HelpOutlineOutlined } from '@mui/icons-material'

const SelectTracks = styled(SelectField)(({ theme }) => ({
  minWidth: theme.spacing(8)
}))

function TractsDropdown({ tracts, onChange }: { tracts: number; onChange: (event: number) => void }) {
  return (
    <SelectTracks
      label={
        <LabelWithIndicator
          label={<FormattedMessage id={`analysis.buffer.tracts`} />}
          icon={
            <Tooltip title={<FormattedMessage id={`analysis.buffer.tractsHelp`} />}>
              <HelpOutlineOutlined />
            </Tooltip>
          }
        />
      }
      labelId="tracts-label"
      defaultValue={tracts ? tracts : 1}
      onChange={(event) => onChange(event.target.value as number)}
    >
      <MenuItem value={1}>1</MenuItem>
      <MenuItem value={2}>2</MenuItem>
      <MenuItem value={3}>3</MenuItem>
      <MenuItem value={4}>4</MenuItem>
    </SelectTracks>
  )
}

export default TractsDropdown
